<ng-scrollbar class="global-container" appearance="compact" #scrollable pointerEventsMethod="scrollbar">
    <div class="col-12" style="height: 94vh;">
<iframe width="100%" height="100%"
            [src]="adcDashboardUrl"
            frameborder="0" 
            class="adc-iframe"
            (load)="onIframeLoad()"
            referrerpolicy="no-referrer">
          </iframe>
        </div>
    </ng-scrollbar>